export enum NotificationTypeEnum {
    GENERAL = "GENERAL",
    STOCK_PROBLEM = "STOCK_PROBLEM",
    NEW_ORDER = "NEW_ORDER",
}

export type TNotificationPriorityType = "critical" | "high" | "medium" | "low";


export interface INotificationEntity {
    id: string;
    createdAt?: Date;
    updatedAt?: Date;
    deletedAt?: Date;
    title: string;
    message: string;
    priority: TNotificationPriorityType;
    type: NotificationTypeEnum;
    metadata: Record<string, any>;
    usersRead: string[];
}

export interface IListNotificationsPayload {
    type?: NotificationTypeEnum[];
    priority?: TNotificationPriorityType;
    page: number;
    offset?: number;
}

export interface IListNotificationsResponse {
    data: INotificationEntity[];
    total: number;
    hasNextPage: boolean;
}